






import ice from "../../lib/ice";
import Vue, { PropType } from "vue";

export interface AProps {
  href: string;
  target: string;
}

export default Vue.extend({
  name: "vc-a",
  props: {
    href: {
      type: String as PropType<AProps["href"]>,
      default: ""
    },
    target: {
      type: String as PropType<AProps["target"]>,
      default: ""
    }
  },
  methods: {
    onClick(event: any) {
      ice.onClickLink(event);
    }
  }
});
